import { Component, inject, input, output, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TenantContext, TenantService } from '../../../core/services/tenant.service';
import { CompanySelectorComponent } from '../company-selector/company-selector.component';
import { EnvironmentBadgeComponent } from '../environment-badge/environment-badge.component';
import { NotificationMenuComponent } from '../notification-menu/notification-menu.component';
import { UserMenuComponent } from '../user-menu/user-menu.component';

/**
 * Topbar fixa: logo + toggle da sidebar + seletor de empresa, badge de
 * ambiente, notificações e menu do usuário. A troca de tenant é orquestrada
 * aqui (setActiveTenant + navegação); o recarregamento de permissões e
 * módulos fica a cargo do AppShellComponent, que reage a
 * TenantService.activeTenantId() — evita duplicar a orquestração.
 */
@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [RouterLink, CompanySelectorComponent, EnvironmentBadgeComponent, NotificationMenuComponent, UserMenuComponent],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
})
export class TopbarComponent {
  private readonly router = inject(Router);
  private readonly tenantService = inject(TenantService);

  readonly sidebarCollapsed = input<boolean>(false);
  readonly toggleSidebar = output<void>();
  readonly openMobileDrawer = output<void>();

  readonly companySelectorOpen = signal(false);

  onToggleSidebar(): void {
    this.toggleSidebar.emit();
  }

  onOpenMobileDrawer(): void {
    this.openMobileDrawer.emit();
  }

  onSwitchCompanyRequested(): void {
    this.companySelectorOpen.set(true);
  }

  onCompanyChange(tenant: TenantContext): void {
    const current = this.tenantService.activeTenantId();
    this.tenantService.setActiveTenant(tenant);
    if (current !== tenant.id) {
      this.router.navigate(['/', tenant.id, 'dashboard']);
    }
  }
}
